import { Paragraph } from "@tvg/design-system/web";
import formatCurrency from "@tvg/formatter/currency";
import React from "react";

export interface AmountValueProps {
  amount: number;
}

const AmountValue = ({ amount }: AmountValueProps) => (
  <Paragraph
    qaLabel="winner-amount"
    color="--fd-colors-system-positive-content-accent"
    fontSize="xl"
    fontFamily="medium"
  >
    {formatCurrency(amount)}
  </Paragraph>
);

export default AmountValue;
